import { atom } from "jotai/index";
import { Language } from "@/config";
import i18next from "i18next";
import { selectAtom } from "jotai/utils";
import { toFormLanguageSelectBox } from "@/pages/Search/search-form-model";

type UserSettingsState = {
  language: Language;
};
export const userSettingsAtom = atom<UserSettingsState>({
  language: i18next.language as Language,
});

export const formLanguageSelectBoxAtoms = selectAtom(userSettingsAtom, (userSetting) => {
  return toFormLanguageSelectBox(userSetting.language);
});
